// step 1
export const initialBatchDetailsState = {
  availableDate: null,
  batchName: null,
  batchOwner: null,
  comments: '',
  component: null,
  fuelType: null,
  isFocus: false,
  origin: null,
  oxygenate: null,
  po: '',
  product: null,
  rvp: null,
  sulphurContent: null,
};

export const initialShipmentState = {
  agreementCode: '',
  bookingOrigin: null,
  comment: '',
  location: null,
  shipper: null,
  volume: '',
};

// step 2
export const initialShipperAllocationState = {
  shipments: [initialShipmentState],
};
